import React, { createContext, useContext, useState, useEffect } from 'react';
import { lockScroll, unlockScroll } from '../../../utils/manager/scrollLock';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [modalStack, setModalStack] = useState([]);
  const [modalData, setModalData] = useState({});

  const openModal = (id, data = {}) => {
    setModalStack((prev) => [...prev, id]);
    setModalData(data || {});
  };

  const closeModal = () => {
    setModalStack((prev) => prev.slice(0, -1));
    setModalData({});
  };

  const closeAll = () => {
    setModalStack([]);
    setModalData({});
  };

  /* useEffect(() => {
    if (modalStack.length > 0) {
      lockScroll();
    } else {
      unlockScroll();
    }
  }, [modalStack]); */

  return (
    <ModalContext.Provider
      value={{ modalStack, modalData, openModal, closeModal, closeAll }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
